import { PrimaryKeySetting, VisibilityType } from 'dbweb-core';

export enum FillAt {
	SkipFill = 0,
	FillAtOpen = 1,
	FillAtSave = 2
}
export interface BillParam {
	Operate: 'add' | 'edit' | 'delete' | 'browse';
	AllowClone: boolean;
	ClonePrimaryKeySettings: PrimaryKeySetting[];
	FieldSettings: FieldSetting[];
	Tag: string;
}

export interface FieldSetting {
	Name: string;
	Fill: string;
	FillAt: FillAt;
	Visibility: VisibilityType;
}
